module.exports = __webpack_public_path__ + "img/logo-confipetrol-dark.7e355b3b.jpg";